export const GROUP_INFO_BLOB_TEST_ID = 'group-info-blob-test-id';
export const GENERAL_GROUP_INFO_TEST_ID = 'general-group-info-test-id';
export const CONTACT_GROUP_INFO_TEST_ID = 'contact-group-info-test-id';
